import { useState } from 'react';
import { reservationService } from '../services/reservationService';
import { tokenManager } from '../services/api/tokenManager';
import {
  CreateReservationRequestDto,
  ReservationResponseDto,
} from '../types/reservation';

export const useReservationActions = () => {
  const [loading, setLoading] = useState(false);

  const createReservation = async (
    data: CreateReservationRequestDto
  ): Promise<ReservationResponseDto> => {
    if (!tokenManager.hasValidTokens()) {
      throw new Error('Usuario no autenticado');
    }
    setLoading(true);
    try {
      const res: ReservationResponseDto = await reservationService.createReservation(data);
      return res;
    } finally {
      setLoading(false);
    }
  };

  const cancelReservation = async (id: string, reason?: string) => {
    if (!tokenManager.hasValidTokens()) {
      throw new Error('Usuario no autenticado');
    }
    setLoading(true);
    try {
      const updated = await reservationService.cancelReservation(id, reason);
      return updated;
    } finally {
      setLoading(false);
    }
  };

  const updateReservationStatus = async (id: string, status: string) => {
    if (!tokenManager.hasValidTokens()) {
      throw new Error('Usuario no autenticado');
    }
    setLoading(true);
    try {
      const updated = await reservationService.updateReservationStatus(id, status);
      return updated;
    } finally {
      setLoading(false);
    }
  };

  const markInUseIssue = async (id: string) => {
    // TODO: Create a modal where the client can report an issue
    return await reservationService.reportIssue(id, 'Reported from client: issue during use');
  };

  const checkAvailability = async (equipmentId: string, from: string, to: string) => {
    setLoading(true);
    try {
      const res = await reservationService.checkAvailability(equipmentId, from, to);
      return res;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    createReservation,
    cancelReservation,
    updateReservationStatus,
    markInUseIssue,
    checkAvailability,
  };
};
